import React from "react";
import { Link } from "react-router-dom";
import Image1 from "../Images/image 1.png";
import Image2 from "../Images/image 2.png";
import Image3 from "../Images/image 3.png";
import "../Styles/ProjectShowcase.css";

function ProjectShowcase() {
  return (
    <section className="showcase-section">
      <div className="showcase-inner">
        <div className="showcase-header">
          <span className="section-label">OUR WORK</span>
          <h2>Featured Projects</h2>
          <p>Take a look at some of our recent work and see the quality difference.</p>
        </div>

        <div className="showcase-grid">
          <div className="showcase-item showcase-large">
            <img src={Image1} alt="Drywall finishing project" />
            <div className="showcase-overlay">
              <div className="showcase-overlay-content">
                <span>Residential</span>
                <h3>Complete Drywall Finishing</h3>
              </div>
            </div>
          </div>
          <div className="showcase-item">
            <img src={Image2} alt="Stucco repair project" />
            <div className="showcase-overlay">
              <div className="showcase-overlay-content">
                <span>Commercial</span>
                <h3>Stucco Repair & Paint</h3>
              </div>
            </div>
          </div>
          <div className="showcase-item">
            <img src={Image3} alt="Popcorn ceiling removal" />
            <div className="showcase-overlay">
              <div className="showcase-overlay-content">
                <span>Residential</span>
                <h3>Popcorn Ceiling Removal</h3>
              </div>
            </div>
          </div>
        </div>

        <div className="showcase-cta">
          <Link to="/contact-us" className="showcase-btn">
            Start Your Project →
          </Link>
        </div>
      </div>
    </section>
  );
}

export default ProjectShowcase;
